import {
  Component, ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {BsModalService} from "ngx-bootstrap/modal";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {OrganisationService} from "../../../../services/organisation/organisation.service";
import moment from "moment";
import {OrgEditRoleModalComponent} from "../org-edit-role-modal/org-edit-role-modal.component";
import * as _ from 'lodash';
import {WarningModalContentComponent} from "../../../../lib/warning-modal/warning-modal.component";
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import {ConstantsService} from "../../../../services/constants/constants.service";
import {OrgUserProfileModalComponent} from "../org-user-profile-modal/org-user-profile-modal.component";
import cloneDeep from 'lodash/cloneDeep';
import {
  ManageSurveyPermissionsModalComponent
} from "../manage-survey-permissions-modal/manage-survey-permissions-modal.component";
import { ManageTeamsComponent } from '../manage-teams/manage-teams.component';
import { NewInviteUserComponent } from '../new-invite-user/new-invite-user.component';
import { UnsavedChangesComponent } from '../unsaved-changes/unsaved-changes.component';
import { NewManageUserComponent } from '../new-manage-user/new-manage-user.component';
import {OrgRemoveUserModalComponent} from "../org-remove-user-modal/org-remove-user-modal.component";
import { OrgUsersService } from '../../services/org-users.service';
import {
  TrustMarketplaceStatusService
} from "../../../../services/trust-marketplace-status/trust-marketplace-status.service";

@Component({
  selector: 'app-org-invite-user',
  templateUrl: './org-invite-user.component.pug',
  styleUrls: ['./org-invite-user.component.scss'],
  standalone: false
})

export class OrgInviteUserComponent implements OnInit, OnChanges {
  manageUserDropDownOptions = [
    {key: '0', value: 'Resend invitation', divider: false,  disabled: true},
    {key: '1', value: 'View user', divider: false,  disabled: true},
    {key: '2', value: 'Manage user role', divider: false,  disabled: true},
    {key: '3', value: 'Manage teams', divider: false,  disabled: true},
    {key: '4', value: 'Manage survey permissions', divider: false,  disabled: true},
    {key: '5', value: 'Clone settings to new user', divider: false,  disabled: true},
    {key: '6', value: 'Remove invitation', divider: true,  disabled: true}
  ];
  @Input() org: any;
  @Input() searchedData = '';
  @Input() invited = false;
  @Output() showUsers = new EventEmitter();
  @Output() resetInvited = new EventEmitter();
  @Output() loader = new EventEmitter();
  kebabMenuOpen = false;
  @ViewChildren('userCardMenu') kebabMenus:any;
  @ViewChild('userInviteeContainer') userContainer:any;
  invitedUsers: any;
  invitedUserDetails!: any;
  userCount!: number;
  total = 5;
  rowsPerView = 20;
  currentPage = 1;
  userRole:any = '';
  filterOptions = [{'label': $localize`Owner`, 'value': 'owner'}, {
    'label': $localize`Admin`,
    'value': 'admin'
  }, {'label': $localize`Member`, 'value': 'member'}, {
    'label': $localize`Member (restricted)`,
    'value': 'member (restricted)'
  }, {'label': $localize`Xref Support`, 'value': 'support'}];
  @Input() filters: any
  @Input() searchQuery = {type: '', search: ''};
  sortOptions = [
    {
      'label': $localize`Invited`,
      'type': "number",
      'value': "invited"
    },
    {
      'label': $localize`Name`,
      'type': "word",
      'value': "name"
    }
  ];

  get newSortOptions() {
    return [
      {
        key: $localize`Email address`,
        value: [
          { label: $localize`A-Z`, sortString: 'name' },
          { label: $localize`Z-A`, sortString: '-name' },
        ],
      },
      {
        key: 'group-end',
        value: [],
      },
      {
        key: $localize`Invited`,
        value: [
          { label: $localize`Newest`, sortString: '-invited' },
          { label: $localize`Oldest`, sortString: 'invited' },
        ],
      }
    ];
  }
  label = '';
  sortString = 'invited';
  sortOrder = 'desc';
  allowResend = false;
  allowRemove = false;
  onfocus = false;
  displayAlert = false;
  allowEditRole = false;
  private bsModalRef: any;
  groupDropDownOptions = [

    {
      'key': 'Invited',
      'value': [
        {'label': 'A-Z', 'sortString': 'invited'},
        {'label': 'Z-A', 'sortString': '-invited'}
      ]
    },
    {
      'key': 'group-end',
      'value': []
    },
    {
      'key': 'Email address',
      'value': [
        {'label': 'Ascending', 'sortString': 'email'},
        {'label': 'Descending', 'sortString': '-email'}
      ]
    }
  ];
  model:any;
  toolTipHeading = $localize`Product permissions`

  constructor(private modalService: BsModalService,
              private organisationService: OrganisationService,
              private alertList: AlertBannerService,
              private permissions: PermissionsService,
              public orgUserService: OrgUsersService,
              public trustMarketplaceStatusService: TrustMarketplaceStatusService) {
    this.onSearch = _.debounce(this.onSearch, ConstantsService.DEBOUNCE_RATE);
  }

  ngOnInit(): void {
    this.label = `${this.newSortOptions[0].key} (${this.newSortOptions[0].value[0].label})`;
    this.userRole = this.permissions.userRole;
    this.displayAlert = this.searchQuery.search !== '';
    this.loadOrgInvitedUsers();

  }

  kebabMenuChange($event, user) {
    if(!$event.disabled){
      if ($event.value == this.manageUserDropDownOptions[0].value) {
        this.resendInvitationModel(user)
      }
      else if ($event.value == this.manageUserDropDownOptions[6].value) {
        this.deleteInvitationModel(user)
      }
      else if ($event.value == this.manageUserDropDownOptions[1].value) {
        this.openViewUserModal(user)
      } else if ($event.key == this.manageUserDropDownOptions[3].key) {
        this.viewTeamModal(user) //
      }
      else if ($event.value == this.manageUserDropDownOptions[4].value){
        this.openManageSurveyPermissions(user)
      } else if ($event.key == this.manageUserDropDownOptions[5].key){
        this.cloneInvitee(user)
      } else if ($event.key == this.manageUserDropDownOptions[2].key) {
        this.manageUser(user)
      }
    }

  }
  openManageSurveyPermissions(user) {

    const initialState = {
      user: user
    }
    this.bsModalRef = this.modalService.show(
      ManageSurveyPermissionsModalComponent,
      Object.assign({}, {class: 'modal-dialog-centered xl-popup', initialState})
    );
    this.bsModalRef.onHide.subscribe(() => {
      this.orgUserService.updateData({});
    })
  }

  viewTeamModal(user): void {
    const initialState = {
      invitee: user,
    }
    this.modalService.show(
      ManageTeamsComponent, {
        class: 'modal-dialog-centered xl-popup',
        initialState
      }
    )
  }

  openViewUserModal(user) {

    const initialState = {
      user: user
    }
    this.bsModalRef = this.modalService.show(
      OrgUserProfileModalComponent,
      Object.assign({}, {class: 'modal-dialog-centered max-width-252', initialState})
    );

  }

  hasinvitePermission(user) {
    const viewUser = this.permissions.hasPermission("can_manage_reference_invitees_and_users") ||
      this.permissions.hasPermission("can_manage_exit_invitees_and_users") ||
      this.permissions.hasPermission("can_manage_pulse_invitees_and_users") ||
      this.permissions.hasPermission("can_manage_backgroundcheck_invitees_and_users")
    const ownerViewUser = this.permissions.hasPermission("can_manage_reference_invitees_and_users") &&
      this.permissions.hasPermission("can_manage_exit_invitees_and_users") &&
      this.permissions.hasPermission("can_manage_pulse_invitees_and_users") &&
      this.permissions.hasPermission("can_manage_backgroundcheck_invitees_and_users")
    if (user.roles?.role.toLowerCase() && viewUser) {
      if(ownerViewUser){
        return true
      }
      else{
        if(this.hasProductPermission(this.userRole, user.roles)){
          return true
        }
      }
    }
    return false
  }


  resendInvitationModel(user) {
    let initialState = {
      headerText: $localize`Resend invitation`,
      confirmationText: $localize`Do you want to resend an invitation to ${user['email']}?`,
      noPermissionText: $localize`The invitation to ${user['email']} contains product access you do not have permission to assign. Please contact your account owner to resend the invitation.`,
      cancelButtonLabel: $localize`Cancel`,
      removeButtonLabel: $localize`Resend`,
      hasPermission: this.hasinvitePermission(user),

    }

    this.bsModalRef = this.modalService.show(OrgRemoveUserModalComponent, {
      class: 'modal-dialog-centered max-width-552',
      initialState,
    });

    this.bsModalRef.content.selection.subscribe((res) => {
      if (res === true) {
        this.organisationService.resendInvitation(user['email']).subscribe(data => {
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! An invitation has been sent to ${user['email']}`,
              keepOnRouteChange: true
            }]);
          }, error => {
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          })
      }
    });

  }

  hasDeletePermission(user){
    const ownerViewUser =
      this.permissions.hasPermission(
        'can_manage_reference_invitees_and_users'
      ) &&
      this.permissions.hasPermission(
        'can_manage_exit_invitees_and_users'
      ) &&
      this.permissions.hasPermission(
        'can_manage_pulse_invitees_and_users'
      ) &&
      this.permissions.hasPermission(
        'can_manage_backgroundcheck_invitees_and_users'
      );
    const viewUser = this.permissions.hasPermission("can_manage_reference_invitees_and_users") ||
      this.permissions.hasPermission("can_manage_exit_invitees_and_users") ||
      this.permissions.hasPermission("can_manage_pulse_invitees_and_users") ||
      this.permissions.hasPermission("can_manage_backgroundcheck_invitees_and_users")

    if (user.roles?.role.toLowerCase() && 'support' == user.roles?.role.toLowerCase() && this.permissions.hasPermission("can_remove_support_user")){
      return true
    }
    else if (user.roles?.role.toLowerCase() && 'owner' == user.roles?.role.toLowerCase() && this.permissions.hasPermission("can_remove_owner_user")){
      return true
    }

    else if (user.roles?.role.toLowerCase() && !['support', 'owner'].includes(user.roles?.role.toLowerCase()) && viewUser) {
      user.dropDown[6]['disabled'] = false;
      if (ownerViewUser) {
        return true
      } else {
        if (this.hasProductPermission(this.userRole, user.roles)) {
          return true
        }
      }
    }
    return false
  }

  deleteInvitationModel(user) {
    let initialState = {
      headerText: $localize`Remove user`,
      confirmationText: $localize`Are you sure you want to remove the invitation to ${user['email']}?`,
      noPermissionText: $localize`The invitation to ${user['email']} contains product access you do not have permission to remove. Please contact your account owner to remove the invitation.`,
      cancelButtonLabel: $localize`Cancel`,
      removeButtonLabel: $localize`Remove`,
      hasPermission: this.hasDeletePermission(user),

    }

    this.bsModalRef = this.modalService.show(OrgRemoveUserModalComponent, {
      class: 'modal-dialog-centered max-width-552',
      initialState,
    });

    this.bsModalRef.content.selection.subscribe((res) => {
      if (res === true) {
        this.loader.emit(false);
        this.organisationService.deleteOrganisationInvitedUser(user).subscribe(data => {
            this.alertList.append([
              {
                type: AlertType.SUCCESS,
                message: $localize`${user['email']} has been removed. If this was done in error, you can invite ${user['email']} to rejoin.`,
                keepOnRouteChange: true,
              },
            ]);
            _.remove(this.invitedUsers, user);
            this.loader.emit(true);
          }, error => {
            console.log(error);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
            this.loader.emit(true);
          })
      }
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.permissions.hasUserOrgPermission('resend_invitation')) {
      this.allowResend = true;
    }
    if (this.permissions.hasUserOrgPermission('remove_invitation')) {
      this.allowRemove = true;
    }
    if (this.permissions.hasUserOrgPermission('set_others_user_role')) {
      this.allowEditRole = true;
    }
    this.userRole = this.permissions.userRole;
    this.displayAlert = this.searchQuery.search !== '';
    if(this.displayAlert){
      this.numberOfUsers()
    }

    this.loadOrgInvitedUsers()

  }

  showUsersView() {
    let updated = {
      "searchData": this.searchedData,
      "view": "Users"
    }
    this.showUsers.emit(updated)
  }

  bannerClicked() {
    let updated = {
      searchData: this.searchQuery.search,
      type: this.searchQuery.type,
      view: 'Users',
    };
    this.showUsers.emit(updated);
  }

  showEditInvitedUserModal(invitedUser) {
    let data = invitedUser;
    data["isUserEdit"] = false;
    data["first_name"] = data['email'].split('@')[0];
    let initialState = {'data': data};
    this.bsModalRef = this.modalService.show(OrgEditRoleModalComponent, {
      class: 'modal-dialog-centered modal-lg', initialState
    });
    this.bsModalRef.content.nextClick.subscribe(res => {
      this.invitedUserDetails = res['data'];
      this.saveInvitedUser(this.invitedUserDetails);
    })

  }


  saveInvitedUser(data) {
    this.organisationService.updateOrganisationUserAndInvitedUser(data.payload, data.isUserEdit).subscribe(data => {
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! Changes have been saved.`,
        keepOnRouteChange: true
      }]);
      this.deprecatedLoadOrgInvitedUsers();
    }, error => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  numberOfUsers() {
    if (this.org === undefined) return;
    this.organisationService.getUserFilterCount(this.searchQuery.type, this.searchQuery.search, this.filters).subscribe(data => {
      this.userCount = data['total_users'];
    }, error => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })

  }

  deprecatedNumberOfUsers() {
    if (this.org === undefined) return;
    this.organisationService.getUserCount(this.searchedData).subscribe(data => {
      this.userCount = data['total_users'];
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  deleteInvitedUser(invitedUser) {
    let initialState = {
      "title": $localize`Remove invitation?`,
      "message": $localize`Are you sure you want to remove the invitation to ${invitedUser['email']}`
    };
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        this.organisationService.deleteOrganisationInvitedUser(invitedUser).subscribe(data => {
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`${invitedUser['email']} has been removed from ${this.org['brand_name']}. If this was done in error, you can invite ${invitedUser['email']} to rejoin.`,
            keepOnRouteChange: true
          }]);
          _.remove(this.invitedUsers, invitedUser);
        }, error => {
          console.log(error);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        })
      }
    })
  }

  resendInvitation(invitedUser) {
    let initialState = {
      "title": $localize`Resend invitation?`,
      "message": $localize`Do you want to resend an invitation to ${invitedUser['email']}`
    };
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        this.organisationService.resendInvitation(invitedUser['email']).subscribe(data => {
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! An invitation has been sent to ${invitedUser['email']}`,
            keepOnRouteChange: true
          }]);
        }, error => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        })
      }
    })
  }

  onPageChange(pageNumber) {
    this.currentPage = pageNumber;
    this.loadOrgInvitedUsers()
  }

  onPageSizeChange(rowsPerView) {
    this.rowsPerView = rowsPerView;
    this.currentPage = 1;
    this.loadOrgInvitedUsers()
  }

  onSortChange(sortString: any): void {
    if (sortString.includes('-')) {
      this.sortOrder = 'desc';
      this.sortString = sortString.substring(1);
    } else {
      this.sortOrder = 'asc';
      this.sortString = sortString;
    }
    this.loadOrgInvitedUsers()
  }

  onNewSortChange(event: {
    sortString: string;
    key: string;
    label: string;
  }): void {

    let sortString = event.sortString;
    this.label = `${event.key} (${event.label})`;
    if (sortString.includes('-')) {
      this.sortOrder = 'desc';
      this.sortString = sortString.substring(1);
    } else {
      this.sortOrder = 'asc';
      this.sortString = sortString;
    }
    this.loadOrgInvitedUsers()
  }

  onFilterChange(filters) {
    this.filters = filters;
    this.deprecatedLoadOrgInvitedUsers();
  }

  onSearch(event) {
  }

  loadOrgInvitedUsers() {
    this.loader.emit(false);
    this.organisationService.retrieveOrganisationInvitedUsers(this.searchQuery.type, this.searchQuery.search, this.rowsPerView, this.currentPage, this.sortString, this.sortOrder, this.filters).subscribe(data => {
      this.invitedUsers = data['invitees'];
      this.total = data['total_invitees'];
      this.invited = false;
      this.resetInvited.emit(this.invited);
      this.translateForDisplay();
      this.loader.emit(true);
    }, error => {
      this.loader.emit(true);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  deprecatedLoadOrgInvitedUsers() {
    if (this.org === undefined) return;
    this.organisationService.getOrganisationInvitedUsers(this.searchedData, this.rowsPerView, this.currentPage, this.sortString, this.sortOrder, this.filters).subscribe(data => {
      this.invitedUsers = data['invitees'];
      this.total = data['total_invitees'];
      this.invited = false;
      this.resetInvited.emit(this.invited);
      this.translateForDisplay();
    }, error => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }
    updateRole(rolesObject) {
    if (rolesObject && rolesObject.products) {
      const products = rolesObject.products;
      for (let product in products) {
        if (products.hasOwnProperty(product)) {
          const roleNumber = products[product];

          if (ConstantsService.PRODUCT_NUMBER_TO_ROLE_MAP.hasOwnProperty(roleNumber)) {
            products[product] = ConstantsService.PRODUCT_NUMBER_TO_ROLE_MAP[roleNumber];
          }
        }
      }
      for (let product in ConstantsService.DEFAULT_ROLES) {
        if (!products.hasOwnProperty(product)) {
          rolesObject.products[product] = ConstantsService.DEFAULT_ROLES[product]
        }
      }
    }
    return rolesObject
  }

  mapToolTip(UserRoles){
    let toolTipRoles = {'role':'member', products:{}}
    for(let product in ConstantsService.DEFAULT_ROLES_LOCALISED){


      if(UserRoles.products?.hasOwnProperty(product)){

        if(product === "Background Checks"){

          this.trustMarketplaceStatusService.trustAdminStatus.subscribe(

            res => {
              if(res == undefined && res != false){
                toolTipRoles.products[ConstantsService.DEFAULT_ROLES_LOCALISED[product]] = UserRoles.products[product]
              }
            }
          );
        }
        else {
          toolTipRoles.products[ConstantsService.DEFAULT_ROLES_LOCALISED[product]] = UserRoles.products[product]
        }}
    }
    return JSON.stringify(toolTipRoles)
  }

  translateForDisplay() {
    if (!Array.isArray(this.invitedUsers)) {
      return;
    }
    for (let orgUser of this.invitedUsers) {
      if (orgUser?.roles?.role === "member") {
        orgUser.roles = this.updateRole(orgUser.roles)
        orgUser["rolesToolTipData"] = this.mapToolTip(orgUser.roles)
      }

      orgUser.dropDown = cloneDeep(this.manageUserDropDownOptions);
      // view user permission
      // manage teams
      const viewUser = this.permissions.hasPermission("can_manage_reference_invitees_and_users") ||
        this.permissions.hasPermission("can_manage_exit_invitees_and_users") ||
        this.permissions.hasPermission("can_manage_pulse_invitees_and_users") ||
        this.permissions.hasPermission("can_manage_backgroundcheck_invitees_and_users")
      const ownerViewUser = this.permissions.hasPermission("can_manage_reference_invitees_and_users") &&
        this.permissions.hasPermission("can_manage_exit_invitees_and_users") &&
        this.permissions.hasPermission("can_manage_pulse_invitees_and_users") &&
        this.permissions.hasPermission("can_manage_backgroundcheck_invitees_and_users")
      if (orgUser.roles?.role && orgUser.roles?.role?.toLowerCase() && viewUser) {
        orgUser.dropDown[3]['disabled'] = false;
        orgUser.dropDown[0]['disabled'] = false;
        orgUser.dropDown[1]['disabled'] = false;
      }

      // if current user and orgUser is same then manage user role is disable
      const manageRole = this.permissions.hasPermission("can_set_reference_role") ||
          this.permissions.hasPermission("can_set_pulse_role") ||
          this.permissions.hasPermission("can_set_exit_role") ||
          this.permissions.hasPermission("can_set_backgroundcheck_role")
      if (orgUser.roles?.role && orgUser.roles?.role?.toLowerCase() && manageRole) {
        if ('owner' != orgUser.roles?.role?.toLowerCase() || ('owner' == orgUser.roles?.role?.toLowerCase() && this.userRole?.role?.toLowerCase() == 'support')){
          orgUser.dropDown[2]['disabled'] = false;
        }
      }

      // manage survey permission
      const manageSurvey = this.permissions.hasPermission("can_manage_reference_user_survey_permissions") ||
        this.permissions.hasPermission("can_manage_pulse_user_survey_permissions") ||
        this.permissions.hasPermission("can_manage_exit_user_survey_permissions") ||
        this.permissions.hasPermission("can_manage_backgroundcheck_user_survey_permissions") ||
        this.permissions.hasPermission("can_manage_reference_user_survey_permissions_with_survey_perms") ||
        this.permissions.hasPermission("can_manage_pulse_user_survey_permissions_with_survey_perms") ||
        this.permissions.hasPermission("can_manage_exit_user_survey_permissions_with_survey_perms") ||
        this.permissions.hasPermission("can_manage_backgroundcheck_user_survey_permissions_with_survey_perms")
      if (orgUser.roles?.role && orgUser.roles?.role?.toLowerCase() && manageSurvey) {
        orgUser.dropDown[4]['disabled'] = false;
      }
      // if orguser is owner/support then cloned setting is disable
      if (orgUser.roles?.role && orgUser.roles?.role?.toLowerCase() && !['support', 'owner'].includes(orgUser.roles?.role?.toLowerCase()) && viewUser){
        if(ownerViewUser){
          orgUser.dropDown[5]['disabled'] = false;
        }
        else{
          if(this.hasProductPermission(this.userRole, orgUser.roles)){
            orgUser.dropDown[5]['disabled'] = false;
          }
        }
      }

      // remove user/inviteee can_manage_reference_invitees_and_users + owner check + support check
      if (orgUser.roles?.role && orgUser.roles?.role.toLowerCase() && 'support' == orgUser.roles?.role.toLowerCase() && this.permissions.hasPermission("can_remove_support_user")){
        orgUser.dropDown[6]['disabled'] = false;
      }
      else if (orgUser.roles?.role && orgUser.roles?.role?.toLowerCase() && 'owner' == orgUser.roles?.role.toLowerCase() && this.permissions.hasPermission("can_remove_owner_user")){
        orgUser.dropDown[6]['disabled'] = false;
      }

      else if (orgUser.roles?.role && orgUser.roles?.role.toLowerCase() && !['support', 'owner'].includes(orgUser.roles?.role.toLowerCase()) && viewUser) {
        orgUser.dropDown[6]['disabled'] = false;
      }


      if (orgUser["invited"] !== null) {
        orgUser['invited'] = moment.unix(orgUser['invited']).format('MMM DD, YYYY')
      }
      if (orgUser['last_access'] !== null) {
        orgUser['last_access'] = moment.unix(orgUser['last_access']).format('MMM DD, YYYY')
      }
    }

  }

  hasProductPermission(currentUserRole: any, orgUserRole: any): boolean {
    const currentUserProducts = currentUserRole.products || {};
    const orgUserProducts = orgUserRole.products || {};

    if (orgUserRole.role.toLowerCase() == 'owner') {
      return false;
    }

    for (const key in orgUserProducts) {
      if (orgUserProducts[key] !== 'None') {
        if (!currentUserProducts.hasOwnProperty(key) || (currentUserProducts.hasOwnProperty(key) && currentUserProducts[key] == '0')) {
          return false;
        }
      }
    }
    return true;
  }


  invitedUserName(email: string) {
    return email.split("@")[0]
  }

  cloneInvitee(user:any){
    this.loader.emit(false);
    this.organisationService.cloneInvitee(user.id).subscribe(data => {
      this.loader.emit(true);
      const memberOptions = this.getMembersOptions(data);
      const initialState = {
        selectedTeams: data.data.teams,
        selectedSurveys: data.data.surveys.map((survey) => ({...survey, is_permitted: true})),
        memberOptions: memberOptions,
        cloneData: user,
        selectedRole: user.roles.role === 'member' ? 'Member' : user.roles.role,
        cloned: true
      };
      this.openInviteUserModal(initialState);
    }, (error) => {
      this.loader.emit(true);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  getMembersOptions(data) {
    const loggedInUserRole: any = this.permissions.role;
    return ConstantsService.getMemberOptions().map((member) => {
      if (data.data.roles.products) {
        const selectedProduct = data.data.roles.products[member.name];
        if (
          (loggedInUserRole.role === 'member' &&
            !this.permissions.getUsersControlPermissionName(member.name))
        ) {
          return { ...member, disabled: true };
        }
        return {
          ...member,
          selected: selectedProduct ? ConstantsService.memberRolesValue[selectedProduct] : member.selected,
          key: selectedProduct ? selectedProduct : member.key,
        };
      }
      return member;
    });
  }

  openInviteUserModal(initialState) {
    this.model = this.modalService.show(
      NewInviteUserComponent,
      {
        class: 'modal-dialog-centered m-popup',
        initialState
      }
    );
    this.model.content.saveClick.subscribe((data) => {
      const content = this.model.content;
      if (data == 'success') {
        const payload = {
          email: content.email,
          teams: content.selectedTeams.map(
            (teams: any) => teams.global_team_uuid
          ),
          questionnaires: content.selectedSurveys.map((survey) => survey.questionnaire.id),
          role: {
            role: content.selectedRole.toLowerCase(),
            products: content.memberOptions.reduce((acc, member) => {
              acc[member.name] = member.key;
              return acc;
            }, {}),
          },
        };
        this.addUser(payload);
      } else if (data?.error) {
        this.model.content.isValid = false;
        content.errors = [{
          enabled: true,
          msg: data.error,
          name: 'wrongPattern',
        }];
      }
    });
    this.model.onHide.subscribe((data) => {
      const content = this.model.content;
      const emptyInitialData = content.selectedRole === '' && content.selectedTeams.length === 1 && content.selectedTeams[0].name === 'Default team'
        && content.selectedSurveys.length === 0 && content.email === '';
      if (content.message != 'force-close' && this.alertList.alerts.length < 1 && !emptyInitialData) {
        this.openUnsavedChangesModal(this.model.content);
      }
    });
  }

  openUnsavedChangesModal(content) {
    const unSavedModel:any = this.modalService.show(UnsavedChangesComponent,
      Object.assign({},{class:'modal-dialog-centered s-popup'})
    );
    unSavedModel.onHide.subscribe((data) => {
      if(unSavedModel.content.message === 'confirm'){
        const initialState = {
          selectedTeams: content.selectedTeams,
          selectedSurveys: content.selectedSurveys,
          memberOptions: content.memberOptions,
          cloneData: content.cloneData,
          selectedRole: content.selectedRole,
          email: content.email,
          cloned: content.cloned
        };
        this.openInviteUserModal(initialState);
      }
    })
  }

  addUser(payload: any) {
    this.loader.emit(false);
    this.organisationService.addUser(payload).subscribe((data) => {
      this.model.hide();
      this.loader.emit(true);
      this.loadOrgInvitedUsers();
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! An invitation has been sent to ` + payload['email'],
        keepOnRouteChange: true
      }]);
    }, (error) => {
      if (error?.error?.data?.errors?.non_field_errors === 'Invalid email' || error?.error?.data?.errors?.non_field_errors === 'Enter a valid email address.') {
        this.model.content.saveClick.emit({ error: $localize`A valid business email address is required, please review and edit to proceed.` });
        return
      } else if(error?.error?.data?.errors?.user === 'duplicate') {
        this.model.content.saveClick.emit({ error: $localize`A user with email address ${payload.email} already exists.` });
        return
      } else if (error?.error?.data?.errors?.user_email === 'duplicate') {
        this.model.content.saveClick.emit({ error: $localize`An invitation has already been sent to ${payload.email}. Resend invitation.` });
        return;
      } else if (error?.error?.data?.errors?.operation === 'not_permitted') {
        this.model.content.saveClick.emit({ error: $localize`Xref support role can only be assigned to Xref staff.` });
        return;
      }
      this.loader.emit(true);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  manageUser(user: any) {
    let memberOptions = ConstantsService.getMemberOptions();
    let loggedInUserRole: any = this.permissions.role;
    if(user.roles.role === 'member'){
      memberOptions = memberOptions.map((member) => {
        if(user.roles.products) {
          const selectedProduct = user.roles.products[member.name]
          if(
            (loggedInUserRole.role === 'member' && !this.permissions.getUsersControlPermissionName(member.name))
          ) {
            return {...member,
              selected: selectedProduct ? ConstantsService.memberRolePlaceHolders[selectedProduct] : member.selected,
              key: selectedProduct ? ConstantsService.memberRoleKeyValue[selectedProduct] : member.key,
              disabled: true}
          }
          return {
            ...member,
            selected: selectedProduct ? ConstantsService.memberRolePlaceHolders[selectedProduct] : member.selected,
            key: selectedProduct ? ConstantsService.memberRoleKeyValue[selectedProduct] : member.key
          }
        }
        return member;
      })
    }
    this.showManageUserModal({
      selectedRole: user.roles.role,
      memberOptions: memberOptions,
      user: user
    })

  }

  showManageUserModal(initialState) {
    const manageUserModel: any = this.modalService.show(
      NewManageUserComponent,
      {
        class: 'modal-dialog-centered new-manage-user-modal m-popup',
        initialState
      }
    )
    manageUserModel.onHide?.subscribe(() => {
      const content = manageUserModel.content;
      if (content.message === 'confirm') {
        const payload = {
          user_uid: content.user.id,
          email: content.user.email,
          teams: [],
          role: {
            role: content.selectedRole.toLowerCase(),
            ...(content.selectedRole == 'member' && {
            products :  content.memberOptions.reduce((acc, member) => {
              acc[member.name] = member.key;
              return acc;
            }, {})
          })
        }}
        this.updateUser(payload);
      }
    });
  }

  updateUser(payload) {
    this.loader.emit(false);
    this.organisationService.updateOrganisationUserAndInvitedUser(payload, false).subscribe((data) => {
      this.loader.emit(true);
      this.loadOrgInvitedUsers();
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! Changes have been saved.`,
        keepOnRouteChange: true
      }]);
    }, (error) => {
      this.loader.emit(true);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  onMenuStateChange(isOpen: boolean): void {
    this.kebabMenuOpen = isOpen;
  }

  ngAfterViewInit() {
    const container = document.querySelector('.invitee-container');
    if (container) {
      container.addEventListener('scroll', this.onScroll.bind(this));
    }


  }

  ngOnDestroy() {
    const container = document.querySelector('.invitee-container');
    if (container) {
      container.removeEventListener('scroll', this.onScroll.bind(this));
    }

  }

  onScroll(): void {
    if (this.kebabMenuOpen) {
      this.userContainer.nativeElement.click()
      const kebabMenusArray = this.kebabMenus.toArray();
      kebabMenusArray.forEach((kebabMenu: ElementRef) => {
        const button = kebabMenu.nativeElement.children[0]?.children[0]?.children[0];
        if (button) {
          button.blur();
        }
      });
    }

  }



}
